<div class="form-section" [formGroup]="fiCellPreferenceForm">
  <div class="form-section-header fw-500">
    {{ headerName }} Cell Phone Preference
  </div>
  <div class="pr-txt-wrapper-container">
    <div class="pr-txt-wrapper fs14">
      {{ preferenceMessage }}
    </div>
    <div class="pr-radio-box">
      <label class="radio-container">
        Yes, the
        {{ headerName === 'FI' ? 'financial institution' : 'organization' }}
        will allow cell phone number details.
        <input
          type="radio"
          formControlName="allowCellPhoneDetails"
          [value]="true"
        />
        <span
          [class.radio-disabled]="isDisabled"
          [class.allow]="isDisabled"
          class="radio-checkmark"
        ></span>
      </label>
    </div>
    <div class="pr-radio-box">
      <label class="radio-container">
        No, the
        {{ headerName === 'FI' ? 'financial institution' : 'organization' }}
        will not allow cell phone number details.
        <input
          type="radio"
          formControlName="allowCellPhoneDetails"
          [value]="false"
        />
        <span
          [class.radio-disabled]="isDisabled"
          [class.allow]="isDisabled"
          class="radio-checkmark"
        ></span>
      </label>
    </div>
  </div>
</div>
